<script setup lang="ts">
import { Digits5Schema } from '~/schemas/5-digits';

const route = useRoute();
const { data: page } = await useAsyncData(() => 
  queryCollection('ProductPages').path(route.path).first()
);

useSeoMeta({
  title: page.value?.metaTitle,
  description: page.value?.metaDescription,
});

useHead({
  link: [
    { rel: "canonical", href: page.value?.linkCanonical },
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify(Digits5Schema)
    },
  ],
});
</script>

<template>
  <template v-if="page">
    <RoundDigitNumberHero
      :title="page.title"
      :sub-title="page.subTitle"
      :description="page.description"
      :img="page.img"
    />
    <div class="gridClass">
      <LazySectionsFeatures 
        :title="page.features.title"
        :desc="page.features.desc"
        :features="page.features.items"
      />
    </div>
    <LazyRoundServiceInfo digitNumber="5" />
    <LazyRoundProcessSteps title="مراحل دریافت خط 5 رقمی از نواتل" />
    <div class="w-full section-py bg-[url('/img/square-bg-02.webp')] bg-size-[100%_auto]">
      <div class="gridClass">
        <h2>چه کسب‌وکارهایی از خط 5 رقمی استفاده می‌کنند؟</h2>
        <LazyRoundUseCases 
          class="mt-15"
          :items="page.useCases ?? []"
        />
      </div>
    </div>
    <div class="gridClass">
      <SectionsFAQ
        :title="page.FAQ.title"
        :items="page.FAQ.items"
      />
    </div>
  </template>
</template>